import { type ReactNode } from 'react';
import clsx from 'clsx';
import { Text } from 'Text';

type Props = {
    title: string;
    description: ReactNode;
    descriptionExtra?: ReactNode;
    className?: string;
    // The right-aligned control (switch, select, button, spinner, etc.).
    children: ReactNode;
};

// Shared layout for a single preferences row: a title + description on the start side
// and a control on the end side. Keeps the row scaffolding (spacing, typography) in one
// place so the individual row components only own their control.
export function SettingRow({ title, description, descriptionExtra, className, children }: Props) {
    return (
        <div className={clsx('flex items-center justify-between gap-6 py-4 sm:gap-16', className)}>
            <div className="flex flex-col">
                <Text as="div" color="black" weight="semibold" className="text-sm">
                    {title}
                </Text>
                <Text as="div" variant="small" className="mt-1">
                    {description}
                </Text>
                {descriptionExtra ? (
                    <Text as="div" variant="small" className="mt-1">
                        {descriptionExtra}
                    </Text>
                ) : null}
            </div>
            <div className="flex-shrink-0">{children}</div>
        </div>
    );
}
